<template>
  <div class="external-table">
    <main class="list-table mt-5">
      <div class="col-md-12 text-right">
        <div class="buttons">
          <button
            @click="downloadTable"
            class="btn-download"
          >{{ $t("events.listEvents.donwloadBtn") }}</button>
        </div>
      </div>

      <v-server-table
        :columns="table_options.columns"
        :options="table_options.options"
        ref="userTable"
      >
        <template #markAsEnter="props" v-if="isHappening">
          <button
            class="confirmed-btn"
            @click="openModal(props.row)"
          >{{ $t("events.listEvents.markAsEnter") }}</button>
        </template>
      </v-server-table>
    </main>
    <Modal v-if="modalActive || busyModalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title">{{ $t("events.guest.modal.atention") }}</h6>
      </template>
      <template>
        <p v-if="modalActive">{{ $t("events.listEvents.markAsEnterAlert") }}</p>
        <p v-if="modalActive">{{ $t("events.listEvents.sureText") }}</p>
        <!-- Body del busymodal -->
        <p v-if="busyModalActive">{{ $t("events.eventBusyModal.alert") }}</p>
        <p v-if="busyModalActive">{{ $t("events.eventBusyModal.body") }}</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-4" @click="closeModal">
            {{
            $t("map.benefits.list.modal.cancel")
            }}
          </span>
          <span
            type="control button"
            class="control entered-btn"
            @click="changeUserToEnteredTable(userInfo)"
          >{{ $t("events.listEvents.markAsEnter") }}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/Events.js";
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");
import Json2Csv from "vue-json-to-csv";

export default {
  components: {
    Modal,
    Json2Csv
  },
  props: ["isHappening", "quantity"],
  data() {
    return {
      items: null,
      folio: "",
      page: 0,
      modalActive: false,
      userInfo: null,
      items: [],
      csvData: null,
      busyModalActive: false,
      dictionary: {
        code: this.$t(
          "events.listEvents.tabs.externalGuest.table.headings.code"
        ),
        email: this.$t(
          "events.listEvents.tabs.externalGuest.table.headings.email"
        )
      }
    };
  },
  methods: {
    async downloadTable() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let id = this.$route.params.id;
        const resp = await api.downloadEventTable(id, "external");
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    openModal: function(user) {
      this.userInfo = user;
      if (this.quantity === 0 || this.quantity < 0) {
        this.busyModalActive = true;
      } else {
        this.modalActive = true;
      }
    },
    closeModal: function() {
      this.modalActive = false;
      this.busyModalActive = false;
    },
    async changeUserToEnteredTable(userInfo) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let idEvent = this.$route.params.id;
        const resp = await api.markAsEntered(userInfo.code, idEvent);
        this.$refs.userTable.refresh();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    }
  },
  computed: {
    userTable: function() {
      return this.$refs.userTable;
    },
    table_columns: function() {
      // if (this.users) return ['select', ...Object.keys(this.users[0])];
      // return null;
      return ["code", "email", "markAsEnter"];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(
            `events.listEvents.tabs.externalGuest.table.headings.${column}`
          );
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(
        column => column !== "markAsEnter" && column !== "code"
      );
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPage: 10,
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler")
          },

          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.filter = "external";
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              let id = this.$route.params.id;
              const resp = await api.getGuestsByStatus(data, id);

              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit(
                "global/SET_RESP",
                resp.users.busyPlacesResult
              );
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.users.result,
              count: response.users.subTotal
            };
          }
        }
      };
    },
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    }
  }
};
</script>

<style lang="scss">
#user-search {
  .pull-right {
    float: none;
  }
  .VueTables .dropdown {
    display: none !important;
  }
  .VueTables .dropdown > button {
    @extend %audi;
    color: $black;
    background-color: transparent;
    border: 1px solid $black;
    border-radius: 0;
    padding: 5px 10px;
  }
  .VueTables .dropdown .dropdown-menu {
    padding: 1rem;
    a {
      color: $black;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    a > input {
      margin-right: 0.5rem;
    }
    input[type="checkbox"][value="select"] {
      display: none;
    }
  }
  .VueTables__table.table {
    min-width: 100%;
    width: max-content;
  }
  .VueTables__table .select-column {
    position: sticky;
    left: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      left: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .select-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .select-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
  .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }
}
</style>
<style>
.confirmed-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;
  padding: 0.5rem;
}
.external-table .modal-container {
  max-width: 40vw !important;
  min-width: 40vw !important;
}
.external-table .controls {
  display: flex;
  justify-content: end;
  align-items: flex-end;
}
.external-table .controls .cancel-btn,
.external-table .controls .entered-btn {
  cursor: pointer;
}
.dropdown {
  display: none !important;
}
</style>
